import { Backdrop, Box, CircularProgress, Container, Divider, Grid, IconButton, Typography } from '@material-ui/core'
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles'
import {
    Add as AddIcon,
    ArrowBack, Check as CheckIcon, Edit as EditIcon, Save
} from '@material-ui/icons'
import MUIDataTable from "mui-datatables"
import { useSnackbar } from 'notistack'
import React, { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useHistory } from "react-router-dom"
import * as Yup from 'yup'
import CheckBox from '../../../components/Form/Checkbox'
import Select from '../../../components/Form/Select'
import SelectPartNumber from '../../../components/Form/SelectPartNumber'
import SelectRackType from '../../../components/Form/SelectRackType'
import TextField from '../../../components/Form/TextField'
import ButtonUI from '../../../components/ui/ButtonUI'
import LoadingUI from '../../../components/ui/LoadingUI'
import PageTitle from '../../../components/ui/PageTitleUI'
import { useAuth } from '../../../hooks/auth'
import { InfoConference100InsertUpdate } from '../../../interfaces/Mvm'
import MvmApi from '../../../services/MvmApi'
import getDefaultGridOptions from '../../../utils/componentUtils'
import permissions from '../../../utils/Permissions'
import { useStyles } from './Style'


const InsertUpdate: React.FC = () => {
    const { enqueueSnackbar } = useSnackbar()
    const history = useHistory()
    const classes = useStyles()
    const [obj, setObj] = useState<any>()
    const [list, setList] = useState<any>([])
    const [suppliers, setSuppliers] = useState<any>([])
    const [allowAdd, setAllowAdd] = useState<boolean>(true)
    const [loading, setLoading] = useState(true)
    const { user, hasPermission } = useAuth()
    const { t: tConference100 } = useTranslation("Conference100")
    const { t: tGeneral } = useTranslation("General")
    const { t: tMvm } = useTranslation("Mvm")
    const { t: tValidation } = useTranslation("Validation")
    const [rowEdit, setRowEdit] = useState<any>(null)
    const [circularLoading, setCircularLoading] = useState<boolean>(false)

    const refFieldCheckBoxCounted = useRef<HTMLInputElement>(null)
    const refFieldCheckBoxWeighed = useRef<HTMLInputElement>(null)
    const refFieldCheckBoxNewCounted = useRef<HTMLInputElement>(null)
    const refFieldCheckBoxNewWeighed = useRef<HTMLInputElement>(null)

    //Campos do Form
    interface IFormSearch {
        mvmNumber?: string;
        shippingSupplier?: string;
        vehiclePlateNumber?: string;
        local?: string;
        type?: any;
        invoice?: string;
        supplier?: any;
        partNumber?: any;
        MDR?: any;
        volumes?: string;
        declared?: string;
        received?: string;
        deem?: string;
        counted?: any;
        weighed?: any;

        newType?: any;
        newMDR?: any;
        newVolumes?: string;
        newReceived?: string;
        newdeem?: string;
        newCounted?: any;
        newWeighed?: any;
    }

    //Metodos do form:
    const { handleSubmit, reset, resetField, control, getValues, setValue, setError, clearErrors } = useForm<IFormSearch>({
        defaultValues: {
            mvmNumber: '',
            shippingSupplier: '',
            vehiclePlateNumber: '',
            local: '',
            type: {},
            invoice: '',
            supplier: {},
            partNumber: {},
            MDR: {},
            volumes: '',
            declared: '',
            received: '',
            deem: '',
            counted: false,
            weighed: false,

            newType: {},
            newMDR: {},
            newVolumes: '',
            newReceived: '',
            newdeem: '',
            newCounted: false,
            newWeighed: false
        }
    });

    useEffect(() => {
        if (!hasPermission(permissions.CONFERENCE.Add))
            history.push('/NoPermission')
    }, [history, user]);

    useEffect(() => {

        var mvmShedId = ''
        var mvmConferenceId = ''

        var parameters = window.location.search.replace('?', '').split("&")

        for (var i = 0; i < parameters.length; i++) {
            if (parameters[i].includes("MvmShedId"))
                mvmShedId = parameters[i].replace('MvmShedId=', '')
            
            if (parameters[i].includes("MvmConferenceId"))
                mvmConferenceId = parameters[i].replace('MvmConferenceId=', '')
        }

        if (!mvmShedId || mvmShedId === '') {
            enqueueSnackbar(tGeneral("objectNotFound"), { variant: 'warning' })
            history.push('/Conference100')
        }

        if (mvmConferenceId && mvmConferenceId !== '')
            setAllowAdd(false)

        setLoading(true)
        setCircularLoading(true)

        const filtro: InfoConference100InsertUpdate = {
            companyId: user.company.companyID,
            mvmConferenceId: mvmConferenceId,
            mvmShedId: mvmShedId
        }

        MvmApi.getConference100ToRegister(filtro)
            .then(result => {
                if(result) {
                    setValue("mvmNumber", result.mvmNumber)
                    setValue("shippingSupplier", result.shippingSupplierCorporateName)
                    setValue("vehiclePlateNumber", result.vehiclePlateNumber)
                    setSuppliers(result.suppliers.map((item: { id: any; supplierCorporateName: any }) => ({ code: item.id, label: item.id + " - " + item.supplierCorporateName, name: item.supplierCorporateName })))
                    setValue("local", result.shedCode)
                    setList(result.items)
                    setObj(result)
                }
            }).catch(() => {
                setList([]);
            }).finally(() => {
                setLoading(false)
                setCircularLoading(false)
            });
    }, [])


    const columns = [
        {
            name: 'conferenceType',
            label: tConference100("type"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "left",
                    }),
                setCellProps: () => ({
                    align: "left"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (rowEdit !== tableMeta.rowIndex)
                        return value
                    else
                        return (
                            <Select
                                label={tConference100('type')} 
                                name={'newType'}
                                control={control}
                                options={[{code: "15%", label: "15%"}, {code: "Precioso", label: "Precioso"}]}                                    
                                style={{width: "100%", marginRight: 10}}
                                allowEnterKey={false} />
                    )
                }
            }
        },
        {
            name: 'invoiceNumber',
            label: tMvm("invoice"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: "supplierCorporateName",
            label: tMvm("supplier"),
            options: {
                setCellProps: () => ({
                    align: "center"
                }),
                setCellHeaderProps: () => ({
                    align: "center",
                }),
            }
        },
        {
            name: "partNumberDescription",
            label: tMvm("partNumber"),
            options: {
                setCellProps: () => ({
                    align: "center"
                }),
                setCellHeaderProps: () => ({
                    align: "center",
                })
            }
        },
        {
            name: "rackTypeDescription",
            label: "MDR",
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (rowEdit !== tableMeta.rowIndex)
                        return value
                    else
                        return (
                            <SelectRackType
                            name={"newMDR"}
                            label={"MDR"}
                            control={control}/>
                               
                    )
                }
            }
        },
        {
            name: 'volumeQuantity',
            label: tConference100("volumes"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (rowEdit !== tableMeta.rowIndex)
                        return value
                    else
                        return (
                            <TextField 
                                label={tConference100("volumes")} 
                                name="newVolumes" 
                                type='number'
                                control={control} 
                                fullWidth />  
                    )
                }
            }
        },
        {
            name: 'declaredQuantity',
            label: tConference100("declared"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: "receivedQuantity",
            label: tConference100("received"),
            options: {
                setCellProps: () => ({
                    align: "center"
                }),
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (rowEdit !== tableMeta.rowIndex)
                        return value
                    else
                        return (
                            <TextField 
                            label={tConference100("received")} 
                            name="newReceived"
                            type='number' 
                            control={control} 
                            fullWidth /> 
                        )
                }
            }
        },
        {
            name: "deem",
            label: tConference100("deem"),
            options: {
                setCellProps: () => ({
                    align: "center"
                }),
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (rowEdit !== tableMeta.rowIndex)
                        return value
                    else
                        return (
                            <TextField 
                            label={"DEEM"} 
                            name="newdeem" 
                            type='number'
                            control={control} 
                            fullWidth /> 
                        )
                }
            }
        },
        {
            name: "counted",
            label: tConference100("counted"),
            options: {
                setCellProps: () => ({
                    align: "center"
                }),
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (rowEdit !== tableMeta.rowIndex)
                        return value ? "Sim" : "Não"
                    else
                        return (
                        <CheckBox onChange={(e) => {if (e.target.checked) setValue("newWeighed", false)}} inputRef={refFieldCheckBoxNewCounted} label={tConference100("counted")} name="newCounted" control={control} style={{marginLeft: 20, marginTop: 7}} />                                
                        )
                }
            }
        },
        {
            name: "weighed",
            label: tConference100("weighed"),
            options: {
                setCellProps: () => ({
                    align: "center"
                }),
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (rowEdit !== tableMeta.rowIndex)
                        return value ? "Sim" : "Não"
                    else
                        return (
                        <CheckBox onChange={(e) => {if (e.target.checked) setValue("newCounted", false)}} inputRef={refFieldCheckBoxNewWeighed} label={tConference100("weighed")} name="newWeighed" control={control} style={{marginLeft: 15, marginTop: 7}} />                       
                    )
                }
            }
        },
        {
            name: '',
            label: '',
            options: {      
                sort: false,
                setCellHeaderProps: () => ({
                    align: "right",
                    }),
                    
                    
                setCellProps: () => ({
                    align: "right"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (rowEdit !== tableMeta.rowIndex)
                        return(<></>)
                    else
                        return (
                            <Box display="flex">
                                <IconButton aria-label="Edit" color="secondary" onClick={() => editRow()}>
                                    <CheckIcon fontSize='small'/>                              
                                </IconButton>
                            </Box>
                        )
                }
            }
        },
    
          {
            name: '',
            label: '',
            options: {
                display: rowEdit === null,
                sort: false,
                setCellProps: () => ({
                    align: "right"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <>
                            <Box display="flex">
                                <IconButton aria-label="Edit" color="primary" onClick={() => setEdit(tableMeta.rowIndex)}>
                                    <EditIcon fontSize='small'/>                             
                                </IconButton>
                            </Box>
                        </>
                    );
                }
            }
        }
    ]
    

    function setEdit(row:number) {
        setRowEdit(row)
        setValue('newType', {code: list[row].conferenceType, label: list[row].conferenceType })
        setValue('newMDR', {rackTypeCode: list[row].rackTypeCode, code: list[row].rackTypeCode, label: list[row].rackTypeDescription })
        setValue('newVolumes', list[row].volumeQuantity)
        setValue('newReceived', list[row].receivedQuantity)
        setValue('newdeem', list[row].deem)
        setValue('newCounted', list[row].counted)
        setValue('newWeighed', list[row].weighed)
    }
    
    const editRow = async () => {

        var data = getValues()

        var validForm = await formValidationUpdate(data)
        if (validForm == false)
            return

        var listTemp = list
        
        listTemp[rowEdit].conferenceType = data.newType.code
        listTemp[rowEdit].MDR = data.newMDR.code
        listTemp[rowEdit].volumeQuantity = data.newVolumes
        listTemp[rowEdit].receivedQuantity = data.newReceived
        listTemp[rowEdit].deem = data.newdeem
        listTemp[rowEdit].counted = data.newCounted
        listTemp[rowEdit].weighed = data.newWeighed

        setList(listTemp)
        setRowEdit(null)
    }

    
    const formValidationInsert = async (data: any) => {
        var result = false
        clearErrors()
        try {
            const schema = Yup.object().shape({              
                type: Yup.object().nullable().required(tValidation("requiredField"))
                    .shape({code: Yup.string().required(tValidation("requiredField"))}),
                supplier: Yup.object().nullable().required(tValidation("requiredField"))
                    .shape({code: Yup.string().required(tValidation("requiredField"))}),
                invoice: Yup.string().nullable().required(tValidation("requiredField")),
                partNumber: Yup.object().required(tValidation("requiredField"))
                    .shape({code: Yup.string().required(tValidation("requiredField"))}),
                MDR: Yup.object().required(tValidation("requiredField"))
                    .shape({code: Yup.string().required(tValidation("requiredField"))}),
                volumes: Yup.string().required(tValidation("requiredField")),
                declared: Yup.string().nullable().required(tValidation("requiredField")),
                received: Yup.string().required(tValidation("requiredField")),
                deem: Yup.string().required(tValidation("requiredField")),
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            result = true
        }
        catch (err) {

            var errors: string[] = []

            if (err instanceof Yup.ValidationError) {
                err.inner.forEach(error => {

                    if (errors.filter(element => element.includes(error.message)).length == 0)
                        errors.push(error.message)

                    setError(error.path?.split('.')[0] as 
                    "type" | 
                    "invoice" | 
                    "supplier" |
                    "partNumber" | 
                    "MDR" | 
                    "volumes" | 
                    "declared" |
                    "received" | 
                    "deem"
                    , { message: error.message });
                })

                errors.forEach(element => { 
                    if (element === tValidation("requiredField"))
                        enqueueSnackbar(tGeneral("requiredFieldsValidation"), { variant: 'warning' }) 
                    else    
                        enqueueSnackbar(element, { variant: 'warning' }) 
                })
            }

            result = false;
        }

        return result
    }

    const formValidationUpdate = async (data: any) => {
        var result = false
        clearErrors()
        try {
            const schema = Yup.object().shape({              
                newType: Yup.object().nullable().required(tValidation("requiredField"))
                    .shape({code: Yup.string().required(tValidation("requiredField"))}),
                newMDR: Yup.object().required(tValidation("requiredField"))
                    .shape({code: Yup.string().required(tValidation("requiredField"))}),
                newVolumes: Yup.string().required(tValidation("requiredField")),
                newReceived: Yup.string().required(tValidation("requiredField")),
                newdeem: Yup.string().required(tValidation("requiredField")),

            });

            await schema.validate(data, {
                abortEarly: false,
            });

            result = true
        }
        catch (err) {

            var errors: string[] = []

            if (err instanceof Yup.ValidationError) {
                err.inner.forEach(error => {

                    if (errors.filter(element => element.includes(error.message)).length == 0)
                        errors.push(error.message)

                    setError(error.path?.split('.')[0] as 
                    "newType" | 
                    "newMDR" | 
                    "newVolumes" 
                    , { message: error.message });
                })

                errors.forEach(element => { 
                    if (element === tValidation("requiredField"))
                        enqueueSnackbar(tGeneral("requiredFieldsValidation"), { variant: 'warning' }) 
                    else    
                        enqueueSnackbar(element, { variant: 'warning' }) 
                })
            }

            result = false;
        }

        return result
    }



    const onSubmit = async (data: any) => {
        setCircularLoading(true)

        MvmApi.postConferences({items: list})
            .then((result) => {
                enqueueSnackbar(tGeneral("returnSubmitEditFormSuccess"), { variant: 'success' })
                history.replace("/Conference100")
                })
            .finally(() => {
                setCircularLoading(false)
            })
    }

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''                    
                }
            },
        }
    })

    const handleIncludeItem = async () => {
        var data = getValues()

        var validForm = await formValidationInsert(data)
        if (validForm == false)
            return

        var newItem = {
            mvmId: obj.mvmId,
            mvmShedId: obj.mvmShedId,
            companyId: user.company.companyID,
            invoiceNumber: data.invoice,
            supplierId: data.supplier.code,
            supplierCorporateName: data.supplier.name,
            partNumberId: data.partNumber.code,
            partNumberCode: data.partNumber.partnumberCode,
            partNumberDescription: data.partNumber.name,
            rackTypeCode: data.MDR.rackTypeCode,
            rackTypeDescription: data.MDR.rackTypeDescription,
            shedCode: obj.shedCode,
            conferenceType: data.type.code,
            volumeQuantity: data.volumes,
            declaredQuantity: data.declared,
            receivedQuantity: data.received,
            deem: data.deem,
            counted: data.counted,
            weighed: data.weighed
        }


        if (list.filter((x: { invoiceNumber: string | undefined; supplierId: any; partNumberId: any }) => 
            x.invoiceNumber === newItem.invoiceNumber && 
            x.supplierId === newItem.supplierId && 
            x.partNumberId === newItem.partNumberId ).length > 0) {
                enqueueSnackbar(tGeneral("registerAlreadyOnList"), { variant: 'warning' })
            return
        }

        setList([...list, newItem])
        
        resetField('type')
        resetField('invoice')
        resetField('supplier')
        resetField('partNumber')
        resetField('MDR')
        resetField('volumes') 
        resetField('declared')
        resetField('received')
        resetField('deem')
        resetField('counted')
        resetField('weighed')
    }

    return (
        <Container maxWidth={false} component="main">
            <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <PageTitle title={tConference100("conference100RegisterTitle")} />
            <div className={classes.rootContent}>
                <div className={classes.paper}>

                    <form translate={undefined} onSubmit={handleSubmit(onSubmit)}  >
                        <Divider style={{ marginTop: '10px' }} />
                        
                        <Grid container spacing={1}>
                            <Grid item xs={1}>
                                <TextField 
                                    label={tMvm("mvmNumber")} 
                                    name="mvmNumber" 
                                    control={control} 
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            readOnly: true,
                                            classes: {
                                                input: classes.inputBlocked,
                                            },
                                        }} />                             
                            </Grid>
                            <Grid item xs={3}>
                                <TextField 
                                    label={tMvm("shippingSupplier")} 
                                    name="shippingSupplier" 
                                    control={control} 
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            readOnly: true,
                                            classes: {
                                                input: classes.inputBlocked,
                                            },
                                        }} />                           
                            </Grid>
                            <Grid item xs={1}>
                                <TextField 
                                    label={tMvm("vehiclePlateNumber")} 
                                    name="vehiclePlateNumber" 
                                    control={control} 
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            readOnly: true,
                                            classes: {
                                                input: classes.inputBlocked,
                                            },
                                        }} />                                
                            </Grid>
                            <Grid item xs={1}>
                                <TextField 
                                    label={tConference100("local")} 
                                    name="local" 
                                    control={control} 
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            readOnly: true,
                                            classes: {
                                                input: classes.inputBlocked,
                                            },
                                        }} />                                
                            </Grid>
                        </Grid>
                        {!allowAdd ? <></> : 
                            <>
                                <Typography className={classes.root} style={{marginTop: 30, marginLeft:5}}>
                                    {tGeneral("insert")}
                                </Typography>
                                <Grid container spacing={1}>
                                    <Grid item xs={1}>
                                        <Select
                                            label={tConference100('type')} 
                                            name={'type'}
                                            control={control}
                                            options={[{code: "15%", label: "15%"}, {code: "Precioso", label: "Precioso"}]}                                    
                                            style={{width: "100%", marginRight: 10}}
                                            allowEnterKey={false} />
                                    </Grid>
                                    <Grid item xs={1}>
                                        <TextField 
                                            label={tMvm("invoice")} 
                                            name="invoice" 
                                            control={control} 
                                            type='number'
                                            fullWidth />                                
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Select
                                            label={tMvm("suppliers")}
                                            name={"supplier"}
                                            options={suppliers}
                                            control={control} 
                                            style={{width: '100%'}} />
                                    </Grid>
                                    <Grid item xs={1}>
                                        <SelectPartNumber
                                            name={"partNumber"}
                                            label={tMvm("partNumber")}
                                            control={control} />                                                                 
                                    </Grid>
                                    <Grid item xs={1}>
                                        <SelectRackType
                                            name={"MDR"}
                                            label={"MDR"}
                                            control={control}
                                        />
                                    </Grid>
                                    <Grid item xs={1}>
                                        <TextField 
                                            label={tConference100("volumes")} 
                                            name="volumes" 
                                            control={control} 
                                            type='number'
                                            fullWidth />                                
                                    </Grid>
                                    <Grid item xs={1}>
                                        <TextField 
                                            label={tConference100("declared")} 
                                            name="declared" 
                                            control={control} 
                                            type='number'
                                            fullWidth />                                
                                    </Grid>
                                    <Grid item xs={1}>
                                        <TextField 
                                            label={tConference100("received")} 
                                            name="received" 
                                            control={control} 
                                            type='number'
                                            fullWidth />                                
                                    </Grid>
                                    <Grid item xs={1}>
                                        <TextField 
                                            label={"DEEM"} 
                                            name="deem" 
                                            control={control} 
                                            type='number'
                                            fullWidth />                                
                                    </Grid>
                                        <CheckBox onChange={(e) => {if (e.target.checked) setValue("weighed", false)}} inputRef={refFieldCheckBoxCounted} label={tConference100("counted")} name="counted" control={control} style={{marginLeft: 15, }} />                                
                                        <CheckBox onChange={(e) => {if (e.target.checked) setValue("counted", false)}} inputRef={refFieldCheckBoxWeighed} label={tConference100("weighed")} name="weighed" control={control} style={{  marginRight: 0}} />                                

                                    <ButtonUI
                                        onClick={() => handleIncludeItem()}
                                        onKeyDown={(e) => {if (e.key === 'Enter') handleIncludeItem(); }}
                                        color="primary"
                                        variant="contained"
                                        style={{ maxWidth: '40px', maxHeight: '38px', minWidth: '40px', minHeight: '38px', marginTop: 20, marginLeft: 0   }}>
                                        <AddIcon />
                                    </ButtonUI>
                                </Grid>
                            </>
                        }
                        {
                            loading ? <LoadingUI /> :
                            <>
                                <Divider style={{ marginTop: '10px' }} />
                                
                                <p>{tGeneral("totalCount")} {("00" + list.length).slice(-2)}</p>
                                
                                <MuiThemeProvider theme={myTheme}>
                                    <MUIDataTable
                                        title=""
                                        data={list}
                                        columns={columns}
                                        options={{
                                            ...getDefaultGridOptions(tGeneral),
                                            serverSide: false,
                                            pagination: false,
                                            sort: false,
                                            selectToolbarPlacement: "none",
                                            filter: false,
                                            search: false,
                                            download: false,
                                            print: false,
                                            viewColumns: false,
                                            selectableRows: 'none'
                                            }}
                                    />
                                </MuiThemeProvider>
                                <Grid container spacing={1} style={{marginTop: 20}}>
                                    <ButtonUI
                                        variant="outlined"
                                        color="secondary"
                                        onClick={() => history.replace("/Conference100")}
                                        startIcon={<ArrowBack />}>
                                        {"Voltar "}
                                    </ButtonUI>
                                    <ButtonUI
                                        style={{marginLeft: 0}}
                                        variant="outlined"
                                        type="submit"
                                        color="primary"
                                        startIcon={<Save />}>
                                        {tGeneral("save")}
                                    </ButtonUI>
                                </Grid>
                            </>
                        }
                    </form>
                </div>
            </div>
        </Container>
    )
}
export default InsertUpdate
